import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getExamRooms } from '~services/api.helpers';

export const useExamRooms = () => {
  const [rooms, setRooms] = useState([]);
  const orgId = useSelector(state => state.user?.data?.ordererOrganization?.id);

  useEffect(() => {
    const update = async () => {
      const newRooms = await getExamRooms(orgId);
      setRooms(newRooms);
    };

    update();
  }, [orgId]);

  return rooms;
};
